$(function () {
    var clipboard = new ClipboardJS('.toClipboard');

    clipboard.on('success', function(e) {
        toastr.info('Zkopírováno do schránky')
        e.clearSelection();
    });
});